import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  maxSize: {
    color: theme.palette.error.main,
  },
}));
